<template>
  <div class="road-data-analysis">
    <div class="right">
      <!-- 查询条件 -->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label>路段名称:</label>
            <input
              v-model="searchForm.roadName"
              class="form-control"
              type="text"
              placeholder="请输入路段名称"
              @keyup.enter="handleSearch"
            />
          </div>
          <div class="form-group">
            <label>统计日期</label>
            <el-date-picker
              v-model="searchForm.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :clearable="false"
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="handleSearch"
                type="button"
                class="btn btn-primary"
              >
                查询
              </button>
            </span>
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="handleExport"
                type="button"
                class="btn btn-primary"
              >
                导出
              </button>
            </span>
          </div>
        </form>
      </div>
      
      <!-- 数据表格 -->
      <div class="list-right">
        <el-table 
          ref="table"
          :data="tableData" 
          border
          v-loading="loading"
          height="100%"
          show-summary
          :summary-method="getSummaries"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
        <el-table-column prop="roadName" label="路段名称" width="150" fixed="left"></el-table-column>
        <el-table-column prop="spaceCount" label="泊位数" width="100" align="right"></el-table-column>
        <el-table-column prop="equipmentType" label="设备类型" width="120"></el-table-column>
        <el-table-column prop="equipmentCount" label="设备数量" width="100" align="right"></el-table-column>
        <el-table-column prop="receivable" label="应收（元）" width="120" align="right">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.receivable) }}
          </template>
        </el-table-column>
        <el-table-column prop="real" label="实收（元）" width="120" align="right">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.real) }}
          </template>
        </el-table-column>
        <el-table-column prop="chargeRate" label="收费率（%）" width="110" align="right">
          <template slot-scope="scope">
            {{ scope.row.chargeRate }}%
          </template>
        </el-table-column>
        <el-table-column prop="arrearsAmount" label="欠费金额（元）" width="130" align="right">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.arrearsAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="arrearsRate" label="欠费率（%）" width="110" align="right">
          <template slot-scope="scope">
            {{ scope.row.arrearsRate }}%
          </template>
        </el-table-column>
        <el-table-column prop="recoveryAmount" label="追缴欠费金额（元）" width="140" align="right">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.recoveryAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="noOrderAmount" label="未下单金额（元）" width="130" align="right">
          <template slot-scope="scope">
            {{ formatMoney(scope.row.noOrderAmount) }}
          </template>
        </el-table-column>
        <el-table-column prop="noOrderRate" label="未下单率（%）" width="110" align="right">
          <template slot-scope="scope">
            {{ scope.row.noOrderRate }}%
          </template>
        </el-table-column>
        <el-table-column prop="orderedCount" label="已下单订单" width="110" align="right">
          <template slot-scope="scope">
            {{ scope.row.orderedCount }}
          </template>
        </el-table-column>
        <el-table-column prop="orderRate" label="下单率（%）" width="110" align="right">
          <template slot-scope="scope">
            {{ scope.row.orderRate }}%
          </template>
        </el-table-column>
        <el-table-column prop="noOrderCount" label="未下单订单" width="110" align="right">
          <template slot-scope="scope">
            {{ scope.row.noOrderCount }}
          </template>
        </el-table-column>
        <el-table-column prop="noOrderRate2" label="未下单率（%）" width="110" align="right">
          <template slot-scope="scope">
            {{ scope.row.noOrderRate2 }}%
          </template>
        </el-table-column>
        </el-table>
      </div>
    </div>
    <Page v-on:pagination="receivePaginationData"></Page>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Page from "../../commons/page";
const dayjs = require("dayjs");

export default {
  name: 'RoadDataAnalysis',
  components: {
    Page
  },
  data() {
    return {
      loading: false,
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      searchForm: {
        roadName: '',
        dateRange: [dayjs().subtract(30, "day").format("YYYY-MM-DD"), dayjs().subtract(1, "day").format("YYYY-MM-DD")]
      },
      tableData: [],
      search: {
        pageSize: 10,
        pageNumber: 1
      },
      tableHeight: 600
    }
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  mounted() {
    this.loadData()
  },
  methods: {
    ...mapMutations(["getPage"]),
    // 接收分页数据
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.loadData();
    },
    // 加载数据
    loadData() {
      this.loading = true
      // 模拟数据，实际应从API获取
      setTimeout(() => {
        this.tableData = [
          {
            roadName: '锦程路',
            spaceCount: 88,
            equipmentType: '地磁',
            equipmentCount: 88,
            receivable: 49552,
            real: 9169,
            chargeRate: 18.5,
            arrearsAmount: 40383,
            arrearsRate: 81.5,
            recoveryAmount: 5230,
            noOrderAmount: 12500,
            noOrderRate: 25.2,
            orderedCount: 320,
            orderRate: 74.8,
            noOrderCount: 108,
            noOrderRate2: 25.2
          },
          {
            roadName: '锦亭路',
            spaceCount: 80,
            equipmentType: '地磁',
            equipmentCount: 80,
            receivable: 39431,
            real: 3892,
            chargeRate: 9.87,
            arrearsAmount: 35539,
            arrearsRate: 90.13,
            recoveryAmount: 4120,
            noOrderAmount: 9800,
            noOrderRate: 24.8,
            orderedCount: 285,
            orderRate: 75.2,
            noOrderCount: 94,
            noOrderRate2: 24.8
          },
          {
            roadName: '智达路',
            spaceCount: 80,
            equipmentType: '地磁',
            equipmentCount: 80,
            receivable: 34988,
            real: 8444,
            chargeRate: 24.1,
            arrearsAmount: 26544,
            arrearsRate: 75.9,
            recoveryAmount: 4560,
            noOrderAmount: 8200,
            noOrderRate: 23.4,
            orderedCount: 298,
            orderRate: 76.6,
            noOrderCount: 91,
            noOrderRate2: 23.4
          },
          {
            roadName: '清源北路',
            spaceCount: 80,
            equipmentType: '地磁',
            equipmentCount: 80,
            receivable: 28543,
            real: 7024,
            chargeRate: 24.6,
            arrearsAmount: 21519,
            arrearsRate: 75.4,
            recoveryAmount: 3890,
            noOrderAmount: 6800,
            noOrderRate: 23.8,
            orderedCount: 268,
            orderRate: 76.2,
            noOrderCount: 84,
            noOrderRate2: 23.8
          },
          {
            roadName: '镇江东路二段',
            spaceCount: 80,
            equipmentType: '地磁',
            equipmentCount: 80,
            receivable: 26789,
            real: 6543,
            chargeRate: 24.4,
            arrearsAmount: 20246,
            arrearsRate: 75.6,
            recoveryAmount: 3650,
            noOrderAmount: 6200,
            noOrderRate: 23.1,
            orderedCount: 275,
            orderRate: 76.9,
            noOrderCount: 82,
            noOrderRate2: 23.1
          },
          {
            roadName: '大兴街',
            spaceCount: 43,
            equipmentType: '地磁',
            equipmentCount: 43,
            receivable: 21543,
            real: 5234,
            chargeRate: 24.3,
            arrearsAmount: 16309,
            arrearsRate: 75.7,
            recoveryAmount: 3420,
            noOrderAmount: 5100,
            noOrderRate: 23.7,
            orderedCount: 245,
            orderRate: 76.3,
            noOrderCount: 76,
            noOrderRate2: 23.7
          },
          {
            roadName: '潆华西路',
            spaceCount: 80,
            equipmentType: '地磁',
            equipmentCount: 80,
            receivable: 31678,
            real: 3124,
            chargeRate: 9.86,
            arrearsAmount: 28554,
            arrearsRate: 90.14,
            recoveryAmount: 2150,
            noOrderAmount: 7800,
            noOrderRate: 24.6,
            orderedCount: 272,
            orderRate: 75.4,
            noOrderCount: 89,
            noOrderRate2: 24.6
          },
          {
            roadName: '潆华东路',
            spaceCount: 80,
            equipmentType: '地磁',
            equipmentCount: 80,
            receivable: 23456,
            real: 2891,
            chargeRate: 12.3,
            arrearsAmount: 20565,
            arrearsRate: 87.7,
            recoveryAmount: 3280,
            noOrderAmount: 5800,
            noOrderRate: 24.7,
            orderedCount: 260,
            orderRate: 75.3,
            noOrderCount: 85,
            noOrderRate2: 24.7
          },
          {
            roadName: '镇江东路一段',
            spaceCount: 80,
            equipmentType: '地磁',
            equipmentCount: 80,
            receivable: 25678,
            real: 4567,
            chargeRate: 17.8,
            arrearsAmount: 21111,
            arrearsRate: 82.2,
            recoveryAmount: 4150,
            noOrderAmount: 6400,
            noOrderRate: 24.9,
            orderedCount: 280,
            orderRate: 75.1,
            noOrderCount: 93,
            noOrderRate2: 24.9
          },
          {
            roadName: '清源南路',
            spaceCount: 80,
            equipmentType: '地磁',
            equipmentCount: 80,
            receivable: 19876,
            real: 3890,
            chargeRate: 19.6,
            arrearsAmount: 15986,
            arrearsRate: 80.4,
            recoveryAmount: 3520,
            noOrderAmount: 4900,
            noOrderRate: 24.6,
            orderedCount: 255,
            orderRate: 75.4,
            noOrderCount: 83,
            noOrderRate2: 24.6
          },
          {
            roadName: '锦华路',
            spaceCount: 80,
            equipmentType: '地磁',
            equipmentCount: 80,
            receivable: 18765,
            real: 3456,
            chargeRate: 18.4,
            arrearsAmount: 15309,
            arrearsRate: 81.6,
            recoveryAmount: 3150,
            noOrderAmount: 4600,
            noOrderRate: 24.5,
            orderedCount: 248,
            orderRate: 75.5,
            noOrderCount: 81,
            noOrderRate2: 24.5
          },
          {
            roadName: '智达南路',
            spaceCount: 80,
            equipmentType: '地磁',
            equipmentCount: 80,
            receivable: 22345,
            real: 4123,
            chargeRate: 18.5,
            arrearsAmount: 18222,
            arrearsRate: 81.5,
            recoveryAmount: 3890,
            noOrderAmount: 5500,
            noOrderRate: 24.6,
            orderedCount: 262,
            orderRate: 75.4,
            noOrderCount: 86,
            noOrderRate2: 24.6
          },
          {
            roadName: '清源中路',
            spaceCount: 80,
            equipmentType: '地磁',
            equipmentCount: 80,
            receivable: 20123,
            real: 3789,
            chargeRate: 18.8,
            arrearsAmount: 16334,
            arrearsRate: 81.2,
            recoveryAmount: 3280,
            noOrderAmount: 5000,
            noOrderRate: 24.8,
            orderedCount: 258,
            orderRate: 75.2,
            noOrderCount: 85,
            noOrderRate2: 24.8
          },
          {
            roadName: '锦程南路',
            spaceCount: 80,
            equipmentType: '地磁',
            equipmentCount: 80,
            receivable: 17654,
            real: 2987,
            chargeRate: 16.9,
            arrearsAmount: 14667,
            arrearsRate: 83.1,
            recoveryAmount: 2980,
            noOrderAmount: 4400,
            noOrderRate: 24.9,
            orderedCount: 245,
            orderRate: 75.1,
            noOrderCount: 80,
            noOrderRate2: 24.9
          },
          {
            roadName: '智达北路',
            spaceCount: 80,
            equipmentType: '地磁',
            equipmentCount: 80,
            receivable: 19876,
            real: 3456,
            chargeRate: 17.4,
            arrearsAmount: 16420,
            arrearsRate: 82.6,
            recoveryAmount: 3420,
            noOrderAmount: 4900,
            noOrderRate: 24.6,
            orderedCount: 252,
            orderRate: 75.4,
            noOrderCount: 82,
            noOrderRate2: 24.6
          }
        ]
        // 设置分页信息
        const pageObj = {
          curIndex: this.search.pageNumber,
          rowsCount: this.tableData.length,
        };
        this.getPage(pageObj);
        this.loading = false
      }, 500)
    },
    
    // 格式化金额
    formatMoney(value) {
      if (!value) return '0'
      return Number(value).toLocaleString('zh-CN')
    },
    
    // 查询
    handleSearch() {
      this.search.pageNumber = 1
      this.loadData()
    },
    
    // 导出
    handleExport() {
      this.$message.success('导出功能开发中...')
    },
    
    // 表格统计方法
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      
      // 确保 sums 数组长度与 columns 一致
      columns.forEach((column, index) => {
        sums[index] = ''
      })
      
      if (!data || data.length === 0) {
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计'
          } else {
            sums[index] = '--'
          }
        })
        return sums
      }
      
      // 计算汇总数据（只汇总数值字段，不汇总百分比）
      const total = data.reduce((sum, item) => {
        return {
          spaceCount: sum.spaceCount + (item.spaceCount || 0),
          equipmentCount: sum.equipmentCount + (item.equipmentCount || 0),
          receivable: sum.receivable + (item.receivable || 0),
          real: sum.real + (item.real || 0),
          arrearsAmount: sum.arrearsAmount + (item.arrearsAmount || 0),
          recoveryAmount: sum.recoveryAmount + (item.recoveryAmount || 0),
          noOrderAmount: sum.noOrderAmount + (item.noOrderAmount || 0),
          orderedCount: sum.orderedCount + (item.orderedCount || 0),
          noOrderCount: sum.noOrderCount + (item.noOrderCount || 0)
        }
      }, {
        spaceCount: 0,
        equipmentCount: 0,
        receivable: 0,
        real: 0,
        arrearsAmount: 0,
        recoveryAmount: 0,
        noOrderAmount: 0,
        orderedCount: 0,
        noOrderCount: 0
      })
      
      // 根据汇总后的数值计算百分比（不是对百分比求平均）
      // 收费率 = (实收总额 / 应收总额) * 100
      const chargeRate = total.receivable > 0 ? ((total.real / total.receivable) * 100).toFixed(2) : '0.00'
      
      // 欠费率 = (欠费总额 / 应收总额) * 100
      const arrearsRate = total.receivable > 0 ? ((total.arrearsAmount / total.receivable) * 100).toFixed(2) : '0.00'
      
      // 未下单率 = (未下单金额 / 应收总额) * 100
      const noOrderRate = total.receivable > 0 ? ((total.noOrderAmount / total.receivable) * 100).toFixed(2) : '0.00'
      
      // 总订单数
      const totalOrders = total.orderedCount + total.noOrderCount
      
      // 下单率 = (已下单订单 / 总订单) * 100
      const orderRate = totalOrders > 0 ? ((total.orderedCount / totalOrders) * 100).toFixed(2) : '0.00'
      
      // 未下单率2 = (未下单订单 / 总订单) * 100
      const noOrderRate2 = totalOrders > 0 ? ((total.noOrderCount / totalOrders) * 100).toFixed(2) : '0.00'
      
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        
        const property = column.property
        if (!property) {
          sums[index] = '--'
          return
        }
        
        switch (property) {
          case 'spaceCount':
            sums[index] = total.spaceCount
            break
          case 'equipmentType':
            sums[index] = '--'
            break
          case 'equipmentCount':
            sums[index] = total.equipmentCount
            break
          case 'receivable':
            sums[index] = this.formatMoney(total.receivable)
            break
          case 'real':
            sums[index] = this.formatMoney(total.real)
            break
          case 'chargeRate':
            sums[index] = `${chargeRate}%`
            break
          case 'arrearsAmount':
            sums[index] = this.formatMoney(total.arrearsAmount)
            break
          case 'arrearsRate':
            sums[index] = `${arrearsRate}%`
            break
          case 'recoveryAmount':
            sums[index] = this.formatMoney(total.recoveryAmount)
            break
          case 'noOrderAmount':
            sums[index] = this.formatMoney(total.noOrderAmount)
            break
          case 'noOrderRate':
            sums[index] = `${noOrderRate}%`
            break
          case 'orderedCount':
            sums[index] = total.orderedCount
            break
          case 'orderRate':
            sums[index] = `${orderRate}%`
            break
          case 'noOrderCount':
            sums[index] = total.noOrderCount
            break
          case 'noOrderRate2':
            sums[index] = `${noOrderRate2}%`
            break
          default:
            sums[index] = '--'
        }
      })
      
      // 确保所有列都有值，防止某些列被遗漏
      for (let i = 0; i < columns.length; i++) {
        if (sums[i] === '' || sums[i] === undefined) {
          sums[i] = '--'
        }
      }
      
      return sums
    }
  }
}
</script>

<style scoped>
.road-data-analysis {
  position: relative;
  height: 100%;
}

.right {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* 搜索区域 */
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
  padding: 10px;
}

.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}

.form-group {
  margin-bottom: 2px;
  margin-right: 10px;
  display: flex !important;
  align-items: center;
}

.form-group label {
  margin-right: 10px;
  font-weight: 100;
  color: #222;
  white-space: nowrap;
}

.form-control {
  border-radius: 4px;
  transition: border-color 0.2s ease;
  border: 1px solid #dcdfe6;
  padding: 0 15px;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #606266;
  width: 200px;
}

.form-control:focus {
  outline: none;
  border-color: #409EFF;
}

.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}

.btn {
  display: inline-block;
  padding: 9px 15px;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  background-color: #fff;
  color: #606266;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-primary {
  background-color: #409EFF;
  border-color: #409EFF;
  color: #fff;
}

.btn-primary:hover {
  background-color: #66b1ff;
  border-color: #66b1ff;
}

.btn-primary:active {
  background-color: #3a8ee6;
  border-color: #3a8ee6;
}

/* 列表区域 */
.list-right {
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  height: calc(100vh - 250px);
  padding-bottom: 20px;
  margin: 10px;
  display: flex;
  flex-direction: column;
}

/* 日期选择器样式 */
.road-data-analysis :deep(.el-date-editor.el-input__inner) {
  max-width: 100% !important;
}

/* 表格统计行样式 */
:deep(.el-table__footer-wrapper) {
  font-weight: 600;
  background: #f5f7fa !important;
}

:deep(.el-table__footer) {
  background: #f5f7fa !important;
}

:deep(.el-table__footer tr) {
  background: #f5f7fa !important;
}

:deep(.el-table__footer td) {
  background: #f5f7fa !important;
  font-weight: 600 !important;
  color: #303133 !important;
  text-align: center !important;
  border-top: 2px solid #409EFF !important;
}

:deep(.el-table__footer .cell) {
  font-weight: 600;
  color: #303133;
  text-align: center;
}
</style>
